import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { StudyPatientInfoQuery, StudyPatientInfoQueryVariables } from '@/shared/api';
import STUDY_PATIENT_INFO_QUERY from '../queries/studyPatientInfo';

/**
 * Loads the patient information attached to a study. Runs STUDY_PATIENT_INFO_QUERY, throws the first GraphQL error message when the study field is nil, and hands back the whole Apollo result rather than the study.
 *
 * @param id - Identifier of the study to load.
 * @returns The raw Apollo query result holding the study patient info.
 */
const fetchStudyPatientInfo = async (id: any) => {
  const client = createClient();
  const studyResult = await client.query<StudyPatientInfoQuery, StudyPatientInfoQueryVariables>({
    query: STUDY_PATIENT_INFO_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = studyResult;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return studyResult;
};

export default fetchStudyPatientInfo;
